























































import { Vue, Component, Prop } from 'vue-property-decorator';

interface IDuplicateData {
  prevYear: number;
  currYear: number;
  dirObj: Record<string, string>;
}

@Component
export default class DuplicatePrevYearDataModal extends Vue {
  @Prop() duplicateData!: IDuplicateData;

  checkedOption = this.dirName;
  
  get dirName() {
    return this.duplicateData.dirObj.name; 
  }

  show() {
    this.$bvModal.show('duplicate-srs-modal');
  }

  handleHide() {
    this.checkedOption = this.dirName;
    this.$bvModal.hide('duplicate-srs-modal');
  }

  handleCancel() {
    this.$bvModal.hide('duplicate-srs-modal')
  }

  handleDuplicate() {
    const payload = {
      checkedOption: (
        this.checkedOption === this.dirName 
        ? this.duplicateData.dirObj 
        : 'all'
      ),
      dirObj: this.duplicateData.dirObj,
      currYear: this.duplicateData.currYear
    }

    this.$emit('selected-dup-option', payload); 
    this.$bvModal.hide('duplicate-srs-modal');
  }
};
